(function ($) {
	/*
	   Mobile header menu toggle
	*/
	$(document).on('click', '.header-main__right__mobile-toggle', function () {
		var $btn = $(this);
		var $wrapper = $btn.closest('.header-main__right__mobile');
		var $menu = $wrapper.find('.header-main__right__mobile-menu');
		var isOpen = $menu.hasClass('is-open');

		$menu.toggleClass('is-open', !isOpen);
		$btn.attr('aria-expanded', !isOpen ? 'true' : 'false');
		$('body').toggleClass('header-main-mobile-open', !isOpen);
	});

})(jQuery);

(function ($) {
	/*
	   Scroll Spy for Project Navigation
	*/
	$(document).ready(function () {
		var $projectNavList = $('.project-nav__list');
		if ($projectNavList.length) {
			var $links = $projectNavList.find('a');
			var scrollSpyObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						var id = entry.target.getAttribute('id');
						var $link = $projectNavList.find('a[href="#' + id + '"]');

						if ($link.length) {
							$projectNavList.find('li').removeClass('active');
							$link.parent('li').addClass('active');
						}
					}
				});
			}, {
				rootMargin: '-20% 0px -60% 0px',
				threshold: 0
			});

			$links.each(function () {
				var href = $(this).attr('href');
				try {
					if (href && href.indexOf('#') === 0 && href.length > 1) {
						var $section = $(href);
						if ($section.length) {
							scrollSpyObserver.observe($section[0]);
						}
					}
				} catch (e) {
					console.warn('Scroll spy error for href: ' + href, e);
				}
			});
		}
	});
})(jQuery);


(function ($) {
	/*
	   Project FAQ accordion
	*/
	$(document).on('click', '.project-faq__question', function () {
		var $button = $(this);
		var $item = $button.closest('.project-faq__item');
		var isOpen = $item.hasClass('is-open');

		$item.toggleClass('is-open', !isOpen);
		$button.attr('aria-expanded', !isOpen ? 'true' : 'false');
	});
})(jQuery);
